const isHTTPS = window.location.protocol === "https:";

export const REACT_APP_API_URL = isHTTPS
    ? process.env.REACT_APP_API_HTTPS_URL
    : process.env.REACT_APP_API_HTTP_URL;
